import React from "react";
import { NavLink } from "react-router-dom";
import logoMark from "../../../assets/logo-mark.png"

interface MobileNavBarBrandProps {
  handleClick: () => void;
}

export const MobileNavBarBrand: React.FC<MobileNavBarBrandProps> = ({
  handleClick,
}) => {
  return (
    <div onClick={handleClick} className="mobile-nav-bar__brand">
      <NavLink to="/" className="mobile-nav-bar__brand-link">
        <img
          className="mobile-nav-bar__logo"
          src={logoMark}
          alt="Strongifier logo"
          height="24"
        />
        <span className="mobile-nav-bar__wordmark">STRONGIFIER</span>
      </NavLink>
    </div>
  );
};
